import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { EMPTY, map, Observable } from 'rxjs';
import { LanguageService } from '../../services/language.service';

@Component({
  selector: 'hazmatsuite-next-loading-spinner',
  templateUrl: './loading-spinner.component.html',
  styleUrls: ['./loading-spinner.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoadingSpinnerComponent {
  @Input() isLoading: Observable<boolean> = EMPTY;

  layoutResource$ = this.languageService.translations$.pipe(map(data => data['LayoutResource']))

  constructor(private languageService: LanguageService) {
    this.languageService.fetchResources(['LayoutResource']);
  }
}
